const UPDATE = (state, data) => {
  state.account.firstname = data.firstname
  state.account.lastname = data.lastname
  state.account.email = data.email
}

const SET_ACCOUNT = (state, account) => {
  state.account = account
}

const SET_STATUS = (state, status) => {
  state.saved = status
}

export default {
  UPDATE,
  SET_STATUS,
  SET_ACCOUNT
}
